//
//
//
//
//
import { maintenance_report } from '@/api/pests';
import reviewResult from './commonDetails.vue';
export default {
  data: function data() {
    return {
      id: null,
      status: null
    };
  },
  props: {},
  watch: {
    '$route': function $route(to, from) {
      this.getParams();
    }
  },
  components: {
    reviewResult: reviewResult
  },
  methods: {
    getParams: function getParams() {
      var route = this.$route;

      if (route) {
        var params = route.params;
        this.id = params.id;
        this.status = params.shStatus;
      }
    }
  },
  mounted: function mounted() {
    this.getParams();
  }
};